import { Form, Input, Spin, Table } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { ColumnsType } from 'antd/lib/table';
import { calculateColumnsWidth } from 'api';
import { MandateLinkDataType, MandateLinkPayload } from 'api/nach';
import './css/gridstyle.css';

type Props = {
  mandateLinkData: MandateLinkPayload[];
  checkedRecord: any;
  setCheckedRecord: (record: any) => void;
  form: FormInstance;
  selectedCIFId?: string;
  filteredMandateData?: string;
};

function MandateLinkGrids({
  mandateLinkData,
  form,
  checkedRecord,
  setCheckedRecord,
  selectedCIFId,
}: Props) {
  // const rules: Rule[] = [{ required: true, type: 'string' }];
  const onSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        console.log('Success:', values);
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
        setCheckedRecord(undefined);
      });
  };
  console.log('selectedCIFId in MandateGrids', selectedCIFId);

  const handleOnlyTenDgit = (e: any) => {
    const inputValue = e.data;
    const newValue = inputValue.toUpperCase(); // Change the value to uppercase

    // Check if the input value contains any non-numeric characters
    if (!/^\d/.test(newValue)) {
      e.preventDefault(); // Prevent the update
      return;
    }
    // console.log('lenght ', e);
    // if (inputValue.length > 10) {
    //   e.preventDefault(); // Prevent the update
    //   return;
    // }
  };

  const selectCheckBox = (record: any) => {
    console.log(record);
    if (record === 'input') {
      onSubmit();
    }
    if (record != 'input') {
      form.resetFields();
    }
    if (record === checkedRecord) {
      setCheckedRecord(undefined);
    } else {
      setCheckedRecord(record);
    }
  };

  const columns: ColumnsType<MandateLinkDataType> = [
    {
      key: 'customerName',
      title: 'Name',
      dataIndex: 'customerName',
      ellipsis: true,
      width: 1000,
      render: (record) => (
        <>
          {record !== '' ? (
            <Input className="customInput" value={record} disabled readOnly />
          ) : (
            <Form.Item
              rules={[

                { required: true, message: 'Please enter customer name' }]}
              name="customerName"
            >
              <Input className="customInput" placeholder="Enter Name" />
            </Form.Item>
          )}
        </>
      ),
    },
    {
      key: 'emailId',
      title: 'Email Id',
      dataIndex: 'emailId',
      width: 1000,
      ellipsis: true,
      render: (record) => (
        <>
          {record !== '' ? (
            <Input className="customInput" value={record} disabled readOnly />
          ) : (
            <Form.Item
              rules={[{ required: true, type: 'email', message: 'Please enter valid email' }]}
              name="emailId"
            >
              <Input className="customInput" placeholder="Enter Email Id" />
            </Form.Item>
          )}
        </>
      ),
    },
    {
      key: 'accountName',
      title: 'Relationship',
      dataIndex: 'accountName',
      ellipsis: true,
      width: 1000,
      render: (record) => (
        <>
          {record !== '' ? (
            <Input className="customInput" value={record} disabled readOnly />
          ) : (
            <Form.Item
              rules={[{ required: true, message: 'Please enter Relationship name' }]}
              name="accountName"
            >
              <Input className="customInput" placeholder="Enter Relationship" />
            </Form.Item>
          )}
        </>
      ),
    },
    {
      key: 'mobileNumber',
      title: 'Mobile Number',
      dataIndex: 'mobileNumber',
      ellipsis: true,
      width: 1000,
      render: (record) => (
        <>
          {record !== '' ? (
            <Input className="customInput" value={record} disabled readOnly />
          ) : (
            <Form.Item
              rules={[
                {
                  required: true,
                  type: 'string',
                  len: 10,
                  message: 'Mobile no must be 10 digits.',
                },
              ]}
              name="mobileNumber"
            >
              <Input
                onBeforeInput={handleOnlyTenDgit}
                className="customInput"
                maxLength={10}
                minLength={10}
                placeholder="Enter Mobile Number"
              />
            </Form.Item>
          )}
        </>
      ),
    },
  ];

  const maxWidthPerCell = 800;
  const dataTable = calculateColumnsWidth(columns, mandateLinkData, maxWidthPerCell);
  const tableHeight = 1000;
  //   const rowKey = 'ROWNUM';
  console.log('dataTable', dataTable);

  const handleChange = () => { };

  return (
    <Spin spinning={false}>
      <Form form={form}>
        <h5 className="search-heading">Select contact from the below list to send Mandate Link</h5>
        <Table
          className="mandateTable"
          rowKey={(record) => record.id}
          rowSelection={{
            type: 'checkbox',
            selectedRowKeys: [checkedRecord],
            onSelect: (record) => selectCheckBox(record.id),
            hideSelectAll: true,
          }}
          columns={dataTable.columns}
          dataSource={dataTable.source}
          pagination={false}
          scroll={{ x: dataTable.tableWidth, y: tableHeight }}
          onChange={handleChange}
        />
      </Form>
    </Spin>
  );
}

export default MandateLinkGrids;
